import React from 'react';
import { Form, Input, Button, Card, Typography, message, theme } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const { Title, Text } = Typography;

const LoginPage = () => {
  const { login, loading } = useAuthStore();
  const navigate = useNavigate();
  const { token: themeToken } = theme.useToken();

  const onFinish = async (values) => {
    const success = await login(values);
    if (success) {
      message.success('Muvaffaqiyatli kirildi!');
      navigate('/');
    } else {
      message.error('Login yoki parol noto\'g\'ri');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 16,
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 420,
          borderRadius: 16,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        }}
        styles={{ body: { padding: '40px 32px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} style={{ margin: 0, color: themeToken.colorPrimary }}>
            Tuyona Admin
          </Title>
          <Text type="secondary">Davlat tashkiloti boshqaruv tizimi</Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="phone"
            rules={[{ required: true, message: 'Telefon kiriting' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Telefon"
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Parol kiriting' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Parol"
              style={{ borderRadius: 8 }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ borderRadius: 8, height: 44, fontWeight: 600 }}
            >
              Kirish
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
